import {trackFootfallEvent} from 'src/utils/analytics';
import Router from 'next/router';
import footfallEventTypes from 'src/constants/footfallEventTypes';
import {createSlug} from 'src/utils/string';
import url from 'url';
import { isIE } from 'src/utils/browser';

export const navigateTo = function (link) {
  if(typeof window !== 'undefined') {
    window.location.assign(link);
  }
};

export const buildPostQuery = (post, community, extraArgs = '') => {
  const postId = post.id || post.postId;
  const communitySlug = community.groupCode || community.slug || community;
  const titleSlug = post.urlEncodedTitle || createSlug(post.title);
  return `/community/singlePost?id=${postId}&context=${communitySlug}&slug=${titleSlug}${extraArgs}`;
};

export const performSearch = (searchString, community = 'all') => {
  const query = encodeURIComponent(searchString);
    // add tracking events to redux when search is handled by dm -
    if (community && community !== 'all') {
      trackFootfallEvent(footfallEventTypes.SEARCHED_COMMUNITY, { searchQuery: query, communityPath: community });
    } else {
      trackFootfallEvent(footfallEventTypes.SEARCHED_SITE, { searchQuery: query });
    }
    if (query) {
      redirectToSearchPage({query, community});
    }
};

export const redirectToSearchPage = ({ query, page = 1, community = 'all'}) => {
  // unexpected issues on IE11 with router push
  if (isIE()) {
    window.location.href = `/search/posts?query=${query}&page=${page}&community=${community}`;
  } else {
    Router.push(`/search?searchType=posts&query=${query}&page=${page}&community=${community}`, `/search/posts?query=${query}&page=${page}&community=${community}`);
  }
};

export const loadJoinCommunityPage = (groupCode) => {
  const communitySlug = !!groupCode ? groupCode : Router.query.context || Router.query.slug;
  if (communitySlug) {
    Router.push(`/community/join?slug=${communitySlug}`, `/join/${communitySlug}`);
  } else {
    window.location = '/join/';
  }
};

export const hardReloadPage = function () {
  window.location.reload();
};

export const getUrlParameter = (param) => {
  if (typeof window !== 'undefined') {
    const sPageURL = window.location.search.substring(1);
    const sURLVariables = sPageURL.split('&');
    for (var i = 0; i < sURLVariables.length; i++) {
      const parameterName = sURLVariables[i].split('=');
      if (parameterName[0] === param) {
        return parameterName[1];
      }
    }
  }
};

export const getExpectedPostUrl = (post, communitySlug, currentUrl) => {
  const { search } = url.parse(currentUrl, true);
  const queryParams = search || '';
  const privatePrefix = post.isPrivate ? '/private' : '';
  return `/${communitySlug}/posts${privatePrefix}/${post.id}/${post.urlEncodedTitle}${queryParams}`;
};



// WEBPACK FOOTER //
// ./src/utils/router.js